<template>
  <div class="ranger">
    <div class="ranger__path" ref="path" @click="onPathClick">
      <div class="ranger__trail" :style="{ width: `${position}px` }" />
      <div v-if="hasThumb" class="ranger__thumb" :style="{ left: `${position}px` }" @mousedown="onThumbDown" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Ranger",
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    hasThumb: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return { position: 0 }
  },

  watch: {
    value(newValue) {
      this.position = this.getPositionFromValue(newValue)
      this.lastValue = newValue
    }
  },

  mounted() {
    this.onMouseMoveHandler = this.onMouseMove.bind(this)
    this.onMouseUpHandler = this.onMouseUp.bind(this)
    this.lastValue = this.$props.value
    this.position = this.getPositionFromValue(this.$props.value)

    window.addEventListener("resize", this.onResize)
  },

  methods: {
    getPositionFromValue(value) {
      const range = this.$props.max - this.$props.min
      value -= this.$props.min
      const position = (value * this.getRect().width) / range
      return position
    },

    getValueFromPosition(position) {
      const range = this.$props.max - this.$props.min
      const width = this.getRect().width
      let value = (range * position) / width
      value += this.$props.min
      return value
    },

    getPositionFromX(x) {
      const pathRect = this.getRect()
      if (x <= pathRect.left) {
        return 0
      } else if (x >= pathRect.right) {
        return pathRect.width
      } else {
        return x - pathRect.left
      }
    },

    getRect() {
      return this.$refs.path.getBoundingClientRect() || {}
    },

    setPosition(position) {
      this.position = position
      const value = this.getValueFromPosition(position)
      if (value !== this.lastValue) {
        this.$emit("change", value, this.lastValue)
        this.lastValue = value
      }
    },

    onThumbDown(event) {
      event.preventDefault()
      document.addEventListener("mouseup", this.onMouseUpHandler)
      document.addEventListener("mousemove", this.onMouseMoveHandler)
    },

    onMouseMove(event) {
      const position = this.getPositionFromX(event.pageX)
      this.setPosition(position)
    },

    onMouseUp() {
      document.removeEventListener("mousemove", this.onMouseMoveHandler)
      document.removeEventListener("mouseup", this.onMouseUpHandler)
    },

    onPathClick(event) {
      const position = this.getPositionFromX(event.pageX)
      this.setPosition(position)
    },

    onResize() {
      this.position = this.getPositionFromValue(this.lastValue)
    }
  }
}
</script>

<style lang="scss">
.ranger {
  $thumb-size: base(1.5);

  min-width: base(10);
  padding-right: $thumb-size / 2;

  &__path {
    position: relative;

    width: 100%;
    height: base(0.5);

    cursor: pointer;
  }

  &__trail {
    position: absolute;
    top: 0;
    left: 0;

    width: 0;
    height: 100%;

    background-color: $blue;
    border-radius: $spacing-4 0 0 $spacing-4;
    cursor: pointer;
  }

  &__thumb {
    position: absolute;
    top: 50%;

    width: $thumb-size;
    height: $thumb-size;

    background: $green;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
